export default "__VITE_ASSET__TrW_vX1___"